import { LookupProps } from 'react-rainbow-components/components/Lookup';
import getOptionForValue from './getOptionForValue';

const getLookupOptions = (results: LookupProps['options'] = [], searchValue?: string) => {
    if (searchValue) {
        return [
            getOptionForValue(searchValue),
            ...results.filter(
                (option) => {
                    const text = typeof option.label === 'string' ? option.label : '';
                    return text.toLowerCase().includes(searchValue.toLowerCase());
                },
            ),
        ];
    }
    return results;
};

export default getLookupOptions;
